import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import { FiltersDashboardContainerProps } from "../../../../interfaces/containers";
import Filters from "../../../../pages/Profile/Dashboard/Filters";
import { setBranchDashboard, setDateDashboard } from "../../../../actions/dashboard";
import { getBranches, cleanBranches } from "../../../../actions/profile";

function mapStateToProps(state: FiltersDashboardContainerProps) {
    return {
        user: state.auth.user,
        branches: state.profile.branches
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        setBranchDashboard,
        setDateDashboard,
        getBranches,
        cleanBranches
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(Filters);